import script from "./vbatchpayment.vue?vue&type=script&setup=true&lang=js"
export * from "./vbatchpayment.vue?vue&type=script&setup=true&lang=js"

import "./vbatchpayment.vue?vue&type=style&index=0&id=b327b01c&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b327b01c"]])

export default __exports__